
<div mat-dialog-title class="_pay-dialog-title">
	<span class="_cap">{{'EX_PAYMENT_MODAL' | translate}}</span>
	<button mat-icon-button mat-dialog-close cdkFocusInitial>
		<mat-icon aria-label="Close Dialog">close</mat-icon>
	</button>
</div>

<div mat-dialog-content>
	<iframe id="add_payment" class="panel" name="add_payment" frameborder="0" scrolling="no"></iframe>
	<form id="send_token" action="" method="post" target="add_payment" style="display:none">
		<input type="hidden" name="token" value="{{data.token}}" />
	</form>
</div>

<div class="provider-logo">
    <img [src]="'assets/images/vendors/authorize.png'" alt="authorize">
</div>
